export const POPUP_STORAGE_KEY = 'limebitesTheme-Popup'

export const POPUP_CLASSNAMES = {
  lightboxActive: 'popup--active',
  lightboxClosing: 'popup--closing',
  success: 'popup--success',
  showImage: 'popup--show-image'
}
